import React, { useContext } from 'react'
import { dataContext, localestr } from '../utils.js'
import EditCtrl from '../cmp/EditCtrl.js'

let loading = false

function DocDebtadjustEdit({ data, actions }) {
  let wndData = {}
  if (data) wndData = data.wndData
  else wndData = actions.getWndData()
  const setWndData = actions.setWndData
  const tabClose = actions.tabClose

  const context = useContext(dataContext)
  const msg = context.msg
  const loaddata = context.loaddata
  const urAdmin = parseInt((context.user || {}).urAdmin || 0)
  const isAuthor = (context.user || {}).id===(wndData.author || {}).id
  let posted = parseInt(wndData.posted || 0) && !urAdmin
  let minDate = (new Date()).toISOString()
  if((context.user || {}).rights?.urDocs3Edit){
    let d = new Date()
    d.setDate(d.getDate() - 3)
    if(minDate > d.toISOString()) minDate = d.toISOString()
  }
  if((context.user || {}).rights?.urDocs7Edit){
    let d = new Date()
    d.setDate(d.getDate() - 7)
    if(minDate > d.toISOString()) minDate = d.toISOString()
  }
  if((context.user || {}).rights?.urDocsREdit){
    if(context.last_rev && context.last_rev < minDate) minDate = context.last_rev
  }
  if(urAdmin){
    let d = new Date()
    d.setDate(d.getDate() - 1095) // 3 роки взад
    if(minDate > d.toISOString()) minDate = d.toISOString()
  }
  if(posted){
    if(wndData.date && wndData.date > minDate){
      if(isAuthor && (context.user || {}).rights?.urDocsOEdit) posted=false  // автор може редагувати свої документи, але врахувати останню ревізію чи дату
      if((context.user || {}).rights?.urDocsSEdit) posted=false  // автор може редагувати чужі документи, але врахувати останню ревізію чи дату
    }
  }

  const setValue = (name, data) => {
    if (posted) return
    let newData = { ...wndData }
    // перевірити чи дата у минулому більше за 90 днів
    // перевірити чи дата у майбутньому
    if (name === 'date') {
      const currentDay = new Date();
      currentDay.setHours(23, 59, 59, 99);
      const inputDay = new Date(data);
      if (inputDay > currentDay) msg(localestr("Цей день ще не настав!"), localestr('Попередження'), [{ caption: 'OK', action: () => { } }]);
      else if ((currentDay - inputDay) / (1000 * 60 * 60 * 24) > 90) msg(localestr("У вас дуже стара дата!"), localestr('Попередження'), [{ caption: 'OK', action: () => { } }]);
    }
    if (data === '') newData[name] = null
    else newData[name] = data
    if (!newData.edit) newData.edit = true
    setWndData(newData, true)
  }

  const saveDoc = (d, close = true) => {
    if (d) {
      loading = false
      const status = d.status
      if (status === 'OffLine') { msg(localestr('Помилка з\'єднання'), localestr('Помилка'), [{ caption: 'OK', action: () => { } }]); return }
      if (status === 'error') { msg(d.msg, localestr('Помилка'), [{ caption: 'OK', action: () => { } }]); return }
      if (wndData.update) wndData.update(d.data)
      tabClose(false)
    } else {
      let data = {}
      if (wndData.edit) {
        if (wndData.id) data.id = wndData.id
        //if(wndData.posted) data.posted=wndData.posted
        //corespond
        data.header = { author: wndData.author, checked: wndData.checked, date: wndData.date, counterpartie: wndData.counterpartie, amount: wndData.sum, posted: wndData.posted, note: (wndData.note || '').substring(0, 85) }
        if (wndData.marked !== '1' && wndData.marked !== 1) data.header.act = 'post'
        if (!wndData.counterpartie) data.header.counterpartie = { id: 'NULL' }
        else if (!wndData.counterpartie.id) data.header.counterpartie = { id: 'NULL' }
        if (!wndData.corespond) data.header.corespond = { id: 'NULL' }
        else if (!wndData.corespond.id) data.header.corespond = { id: 'NULL' }
        if (!wndData.author) data.header.author = { id: 'NULL' }
      }

      if (posted){
        msg(localestr('Не достатньо прав для редагування цього документа'), localestr('Збереження'), [
                { caption: localestr('Відмінити'), action: () => { } },
                { caption: 'Закрити', action: () => { tabClose(false) } }
        ])
        return
      }

      if (Object.keys(data).length) {
        if (parseInt(wndData.posted)) data.posted = 1
        if (parseInt(wndData.marked)) data.marked = 1
      }

      if (loading) return
      loading = true
      setTimeout(() => { loading = false }, 5000)

      if (!close) {
        if (Object.keys(data).length) {
          data.header.act = '';
          loaddata('action=modebtadjust&data=' + encodeURIComponent(JSON.stringify(data)), undefined, (dt) => { saveDoc(dt, close) })
        }
        return
      }

      if (Object.keys(data).length && wndData.posted && parseInt(wndData.posted) > 0) msg(localestr('Зберегти зміни?'), localestr('Збереження'), [
        { caption: 'OK', action: () => { loaddata('action=modDebtadjust&data=' + encodeURIComponent(JSON.stringify(data)), undefined, (dt) => { saveDoc(dt) }) } },
        { caption: localestr('Відмінити'), action: () => { } }
      ])
      else if (Object.keys(data).length && (!wndData.marked || parseInt(wndData.marked) === 0)) msg(localestr('Зберегти зміни?'), localestr('Збереження'), [
        { caption: localestr('Провести'), action: () => { loaddata('action=modDebtadjust&data=' + encodeURIComponent(JSON.stringify(data)), undefined, (dt) => { saveDoc(dt) }) } },
        { caption: localestr('Зберегти'), action: () => { data.header.act = ''; loaddata('action=modDebtadjust&data=' + encodeURIComponent(JSON.stringify(data)), undefined, (dt) => { saveDoc(dt) }) } },
        { caption: localestr('Відмінити'), action: () => { } }
      ])
      else if ((wndData.posted === '0' || wndData.posted === 0) && (wndData.marked !== '1' && wndData.marked !== 1)) msg(localestr('Провести документ?'), localestr('Проведення'), [
        { caption: localestr('Провести'), action: () => { loaddata('action=postDebtadjust&data=' + encodeURIComponent(JSON.stringify({ id: wndData.id })), undefined, (dt) => { saveDoc(dt) }) } },
        { caption: localestr('Відмінити'), action: () => { } }
      ])
      else if ((wndData.marked !== '1' && wndData.marked !== 1)) msg(localestr('Провести документ?'), localestr('Проведення'), [
        { caption: localestr('Закрити'), action: () => { tabClose(false) } },
        { caption: localestr('Провести'), action: () => { loaddata('action=postDebtadjust&data=' + encodeURIComponent(JSON.stringify({ id: wndData.id })), undefined, (dt) => { saveDoc(dt) }) } }
      ])
      else if (close) tabClose(false)
    }
  }

  if (window.innerWidth < 425) {
    return (
      <div style={{ display: 'flex', flexDirection: 'column', margin: '4px 5px 0 5px', height: 'calc(100% - 30px)', outline: 'none', width: 'calc(100% - 10px)' }}>
        <div style={{ margin: '2px 0', display: 'flex', flexDirection: 'row', gap: '5px' }}>
          <EditCtrl Capt={localestr('Коригування боргів')} Value={wndData.id} typeVal={'text'} setVal={(d) => { setValue('id', d) }} width1='93' width2='1' disabled={true} />
          <EditCtrl Capt={localestr('від')} disabled={posted} Value={new Date(wndData.date)} typeVal={'datetime'} setVal={(d) => { setValue('date', d) }} width1='24' width2='43' />
        </div>
        <div style={{ margin: '2px 0', display: 'flex', flexDirection: 'row', gap: '5px' }}>
          <EditCtrl Capt={localestr('Контрагент')} disabled={posted} Value={wndData.account} typeVal={'catCounterparties'} setVal={(d) => { setValue('counterpartie', d) }} width1='80' width2='15' />
          <EditCtrl Capt={localestr('Сума')} disabled={posted} Value={wndData.sum} typeVal={'number2'} setVal={(d) => { setValue('sum', d) }} width1='38' width2='20' />
        </div>
        <EditCtrl Capt={localestr('Примітка')} disabled={posted} Value={wndData.note} typeVal={'text'} setVal={(d) => { setValue('note', d) }} width1='84' width2='100' />
        <div style={{ display: 'flex', flexGrow: '100000' }}>
          <div className='no-print' style={{ margin: '2px 0', display: 'inherit' }}>
            <div style={{ width: '64px', display: 'inline-block', verticalAlign: 'bottom' }} className={'key_btn'} onClick={() => saveDoc()}><div style={{ height: '30px', lineHeight: '30px', display: 'block' }}>OK</div></div>
          </div>
          <div style={{ flexGrow: '10' }}></div>
        </div>
      </div>
    )
  }

  return (

    <div style={{ display: 'flex', flexDirection: 'column', margin: '4px 0', height: 'calc(100% - 10px)' }}>
      <div style={{ margin: '2px 0', display: 'inherit' }}>
        <EditCtrl Capt={localestr('Коригування боргів')} Value={wndData.id} typeVal={'text'} setVal={(d) => { setValue('id', d) }} width1='146' width2='27' disabled={true} />
        <div style={{ width: '8px', display: 'inline-block', flexGrow: 4, maxWidth: '16px' }}></div>
        <EditCtrl Capt={localestr('від')} disabled={posted} Value={new Date(wndData.date)} typeVal={'datetime'} setVal={(d) => { setValue('date', d) }} width1='24' width2='135' />
      </div>
      <div style={{ margin: '2px 0', display: 'inherit' }}>
        <EditCtrl Capt={localestr('Контрагент')} disabled={posted} Value={wndData.account} typeVal={'catCounterparties'} setVal={(d) => { setValue('counterpartie', d) }} width1='80' width2='142' />
        <div style={{ width: '8px', display: 'inline-block', flexGrow: 4, maxWidth: '16px' }}></div>
        <EditCtrl Capt={localestr('Сума')} disabled={posted} Value={wndData.sum} typeVal={'number2'} setVal={(d) => { setValue('sum', d) }} width1='38' width2='72' />
      </div>
      <EditCtrl Capt={localestr('Примітка')} disabled={posted} Value={wndData.note} typeVal={'text'} setVal={(d) => { setValue('note', d) }} width1='84' width2='256' />
      <div style={{ display: 'flex', flexGrow: '100000' }}>
        <div className='no-print' style={{ margin: '2px 0', display: 'inherit' }}>
          <div style={{ width: '64px', display: 'inline-block', verticalAlign: 'bottom' }} className={'key_btn'} onClick={() => saveDoc()}><div style={{ height: '30px', lineHeight: '30px', display: 'block' }}>OK</div></div>
        </div>
        <div style={{ flexGrow: '10' }}></div>
      </div>
    </div>
  )

}

export default DocDebtadjustEdit